<template>
  <div class="flex flex-col p-10">
    <div class="flex flex-row" style="gap: 10px">
      <vs-radio
        v-for="(c, i) in commandOptions"
        :key="i"
        v-model="selectedCommandOption"
        :vs-value="c.value"
        >{{ c.label }}</vs-radio
      >
    </div>
    <div class="flex flex-row items-end mt-3" style="gap: 5px">
      <vs-input
        label-placeholder="Input Value"
        v-model="commandValue"
        style="width: 100%"
        :disabled="
          !commandOptions.find((c) => c.value === selectedCommandOption)
            .withValue
        " />
      <vs-button @click="sendCommand">Send</vs-button>
    </div>
  </div>
</template>

<script>
import * as REPO from '../../repository/index'

export default {
  props: {
    imei: {
      type: String,
      required: true,
    },
    odometer: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      commandValue: '',
      commandOptions: [
        {
          label: 'Set Odometer',
          value: 'odometer',
          withValue: true,
        },
        {
          label: 'Restart GPS module',
          value: 'cpu_reset',
          withValue: false,
        },
        {
          label: 'Custom Command',
          value: 'custom',
          withValue: true,
        },
      ],
      selectedCommandOption: 'odometer',
    }
  },
  mounted() {
    this.commandValue = this.odometer / 1000 // Convert to km
  },
  watch: {
    selectedCommandOption(val) {
      if (val == 'odometer') this.commandValue = this.odometer
      else this.commandValue = ''
    },
  },
  methods: {
    sendCommand() {
      const body = {
        imei: this.imei,
        command: this.selectedCommandOption,
        value: this.commandValue,
      }

      if (
        !this.commandOptions.find((c) => c.value === this.selectedCommandOption)
          .withValue
      ) {
        delete body.value
      }

      //
      REPO.postVehicleCommand(body)
        .then((res) => {
          this.$vs.notify({
            title: 'Success',
            text: 'Command sent successfully',
            color: 'success',
          })
        })
        .catch((err) => {
          this.$vs.notify({
            title: 'Error',
            text: 'Failed to send command',
            color: 'danger',
          })
        })
    },
  },
}
</script>

<style lang="scss" scoped></style>
